import { useQuery } from "@tanstack/react-query";
import {
  fetchPendingFolders,
  fetchPendingSubfolders,
  fetchPendingFiles,
} from "../services/fetchPendingFileHierarchy";

/**
 * Hook to fetch top-level pending submission folders.
 */
export function usePendingFolders() {
  return useQuery({
    queryKey: ["pendingFolders"],
    queryFn: fetchPendingFolders,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch subfolders for a given userId and folderId.
 * @param {string} userId
 * @param {string} folderId
 */
export function usePendingSubfolders(userId, folderId) {
  return useQuery({
    queryKey: ["pendingSubfolders", userId, folderId],
    queryFn: () => fetchPendingSubfolders(userId, folderId),
    enabled: !!userId && !!folderId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch files for a given userId, folderId and subfolderId.
 * @param {string} userId
 * @param {string} folderId
 * @param {string} subfolderId
 */
export function usePendingFiles(userId, folderId, subfolderId) {
  return useQuery({
    queryKey: ["pendingFiles", userId, folderId, subfolderId],
    queryFn: () => fetchPendingFiles(userId, folderId, subfolderId),
    enabled: !!userId && !!folderId && !!subfolderId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
